/* eslint-disable */

import $ from 'jquery';
import loadingLayer from '../../util/loadingLayer';
import formMessages from '../../util/formMessages';

export default {
    init() {
        formMessages().useCaptcha();

        const $form = $('#contact-us-form');
        formMessages($form).validate();

        $form.on('submit', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();
            formMessages($form).init();

            const url = $form.attr('action-ajax') || $form.attr('action');
            const method = $form.attr('method');

            const formData = $form.find("select:visible,input[type=hidden],:input:visible,textarea:visible").serializeArray();
            const data = {};

            for (var i in formData) {
                data[formData[i].name] = formData[i].value;

                $('#' + formData[i].name, $form).removeClass('is-invalid');
                $('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
            }

            $.ajax({
                url,
                method,
                data: {
                    ...data,
                    nonce: window.meta_object.nonce,
                    captcha_token: window.meta_object.captcha_token,
                    action: 'contact-us',
                },
                dataType: 'json',
                complete: function() {
                    formMessages().reloadCaptcha();
                },
                success: function(data) {
                    if (!data) {
                        loadingLayer.hideLoading();
                        return;
                    }

                    if (data.success && data.successUrl) {
                        window.location.replace(data.successUrl);
                        return;
                    }

                    loadingLayer.hideLoading();
                    formMessages($form, data).run();
                },
                error: function(err) {
                    console.log('error', err);
                    loadingLayer.hideLoading();
                }
            });
        });
    },
    finalize() {

    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/blocks/contactUs.js